export default __webpack_public_path__ + "static/media/moments.6cb086bf.svg";